module.exports = __webpack_public_path__ + "static/media/consignaction-logo.e06919be.png";